import * as React from "react";
import { FC } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const ImageOutlinedIcon: FC<{ className?: string }> = (props) => {
    return (
        <SvgIcon viewBox="0 0 48 46" strokeWidth="2" {...props}>
            <g stroke="none" fill="none" fillRule="evenodd">
                <g transform="translate(-504.000000, -257.000000)">
                    <g transform="translate(320.000000, 79.000000)">
                        <g transform="translate(24.000000, 124.000000)">
                            <g transform="translate(154.000000, 48.000000)">
                                <rect fillRule="nonzero" x="0" y="0" />
                                <circle stroke="currentColor" strokeWidth="inherit" cx="45" cy="15" r="7.5" />
                                <polygon
                                    stroke="currentColor"
                                    strokeWidth="inherit"
                                    strokeLinejoin="round"
                                    points="7.5 50 22.5 22.5 32.5 40 42.5 35 52.5 50"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

export default ImageOutlinedIcon;
